import { render, staticRenderFns } from "./OperationV2.vue?vue&type=template&id=35f81a59&scoped=true"
import script from "./OperationV2.vue?vue&type=script&lang=js"
export * from "./OperationV2.vue?vue&type=script&lang=js"
import style0 from "./OperationV2.vue?vue&type=style&index=0&id=35f81a59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f81a59",
  null
  
)

export default component.exports